// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"248265a6e17ec4ceddeb","777":"480dd201600730fd5482","939":"850841657d3d07ff922a"}[chunkId] + ".js";
};